export const data={
    name:"Tisha Garg",
    mailId:"tishag6661@gmail.com",
    profilepic:"https://github.com/Tisha6661/Tisha6661/assets/98682478/12388cf7-0cd7-4d02-a171-b93863063ad0",
    githublink:"https://github.com/Tisha6661",
    workField:"Data Analyst",
    cvlink:"https://docs.google.com/document/d/18p4jawVhNUIdoSHf35h8dZ1B5KDO6FQSSAxp_p5d_G0/edit",
    linkedinLink:"https://www.linkedin.com/in/tisha-garg-4b207322a/",
    onelineyou:"Aspiring Data Analyst and Machine Learner, passionate about creating, engaging and interactive experiences with data using OpenCV and Artificial Intelligence.",
    projects:[{
        title:"Serenity",
        imgLink:"https://cdn-in.icons8.com/yPqGjFz4y06lAX9IolKbzw/s2bVxLF47UiRAAETU4LEBA/Image.png",
        des:"Revive Your Spirit: Say goodbye to stress and hello to inner peace at our online haven",
        gitLink:"/"
    },{
        title:"Auto Park SOL",
        imgLink:"https://cdn-in.icons8.com/MGwxXlsJMkWOT_Yk_K3nAw/t2uTHD0sskOEpfCy52k1Dg/autopark.png",
        des:"A one point solution that allows the users to easily and efficiently park their vehicles without the need for manual guidance. It reads number plate through camera and redirect traffic to the parking lot .",
        gitLink:"/"
    },{
        title:"Book Hive",
        imgLink:"https://drive.google.com/file/d/15krDG6oUx-COFrfZDPb-27fBJqftcUtR/view?usp=share_link",
        des:" An eCommerce store with a powerful book recommendation system.",
        gitLink:"/"
    }],
    skills:[{
        title:"Programming Languages",
        desc:"Python, C, C++, HTML, CSS, JavaScript"
    },{
        title:"Frameworks/Tools/Library",
        desc:"SQL, Machine Learning, Deep Learning, Computer Vision, Relational Database, Power BI ,GitHub , Git, MS Word, MS EXcel, Canva"
    },{
        title:"Coursework",
        desc:"Data Structures , Algorithms, Operating System, Object Oriented Programming, Computer Networks"
    }],
    experience:[{
        "title":"Solving for India Hackathon",
        "desc":"Leaded a team of 4 people in geeksforgeeks hackathon Solving for India "
    },
    {
        "title":"GirlScript Summer of Code 2023",
        "desc":"Acquired Rank 41 and made more than 300+ contributions on github"
    }],
    education:[{
        "title":"JC Bose University , YMCA , Faridabad, Haryana",
        "desc":"Persuing B.Tech in Computer Engineering (with specialization in Data Science), with current CGPA 8.9"
    },{
        "title":"Dr. MKK Arya Model School, Panipat, Haryana",
        "desc":"Completed Class 12th with a remarkable 97.4% score"
    },{
        "title":"Dr. MKK Arya Model School, Panipat, Haryana",
        "desc":"Completed Class 10th with a remarkable 99.2% score, attaining position of District Topper"
    }],
    aboutme:"A dedicated data analyst with a passion for harnessing the power of OpenCV and machine learning to unlock insights from complex datasets. Committed to driving data-driven decision-making with a strong analytical skillset."
};